import { render } from "./App.vue?vue&type=template&id=05c14ecd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=05c14ecd&lang=css"
script.render = render

export default script